import PropTypes from 'prop-types';
import React from 'react';
import { BOOKING_CALENDAR_PAYMENTS } from '../../../../brands/default/content/components/deal';
import { formatCurrency } from '../../../../helpers/currency';
import RadioButtonWithLabel from '../../../_generic/radio-button/RadioButtonWithLabel';

const BookingCalendarPayments = ({
  currency,
  depositPrice,
  fullPrice,
  selection,
  onSelect,
}) => {
  const { depositPayDeposit, depositPayFull } = BOOKING_CALENDAR_PAYMENTS;

  return (
    <>
      <div className="booking-calendar__payments">
        <RadioButtonWithLabel
          checked={selection}
          className="radio-button--boxed radio-button--switch radio-button--green"
          label={
            <>
              <p className="booking-calendar__label-text">
                {depositPayDeposit}
              </p>
              <p className="booking-calendar__label-price">
                {formatCurrency(
                  currency,
                  Number.parseFloat(depositPrice),
                  false,
                  false,
                )}
              </p>
            </>
          }
          onChange={() => onSelect(true)}
        />
        <RadioButtonWithLabel
          checked={!selection}
          className="radio-button--boxed radio-button--switch"
          label={
            <>
              <p className="booking-calendar__label-text">{depositPayFull}</p>
              <p className="booking-calendar__label-price">
                {formatCurrency(
                  currency,
                  Number.parseFloat(fullPrice),
                  false,
                  false,
                )}
              </p>
            </>
          }
          onChange={() => onSelect(false)}
        />
      </div>
      <style jsx>{`
        .booking-calendar__payments {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
        }
        :global(.booking-calendar__payments > label) {
          width: calc(50% - 10px);
        }
        .booking-calendar__label-text {
          font-weight: normal;
          margin: 0;
        }
        .booking-calendar__label-price {
          font-weight: bold;
          margin: 0;
        }
      `}</style>
    </>
  );
};

BookingCalendarPayments.propTypes = {
  currency: PropTypes.string,
  depositPrice: PropTypes.string,
  fullPrice: PropTypes.string,
  onSelect: PropTypes.func,
  selection: PropTypes.bool,
};

BookingCalendarPayments.defaultProps = {
  currency: 'gbp',
  depositPrice: '',
  fullPrice: '',
  onSelect: () => false,
  selection: false,
};

export default BookingCalendarPayments;
